import { AppOverlay } from './AppOverlay';
import type { OverlayShellProps } from './overlay.types';

export type AppDialogProps = OverlayShellProps;

/** Centred modal on the overlay foundation. Default size `sm`; full screen on phones. */
export function AppDialog(props: AppDialogProps) {
  return <AppOverlay variant="dialog" {...props} />;
}
